import UserPathControl from './UserPathControl';
import * as ChartControlBarUI from '../ChartControlBarUI';

const PathControlBar = () => {
  return (
    <ChartControlBarUI.ControlBarRow>
      <UserPathControl />
    </ChartControlBarUI.ControlBarRow>
  );
};

export default PathControlBar;
